import { render, staticRenderFns } from "./StatusSelector.vue?vue&type=template&id=3d61c234&scoped=true"
import script from "./StatusSelector.vue?vue&type=script&lang=js"
export * from "./StatusSelector.vue?vue&type=script&lang=js"
import style0 from "./StatusSelector.vue?vue&type=style&index=0&id=3d61c234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d61c234",
  null
  
)

export default component.exports